import * as React from "react";

function SvgBBiconsErrorNotice(props) {
  return (
    <svg viewBox="0 0 200 200" {...props}>
      <path
        d="M100 1a99 99 0 1099 99 99 99 0 00-99-99zm41.29 129.68a7.5 7.5 0 11-10.61 10.61L100 110.61l-30.68 30.68a7.5 7.5 0 11-10.61-10.61L89.39 100 58.71 69.32a7.5 7.5 0 0110.61-10.61L100 89.39l30.68-30.68a7.5 7.5 0 1110.61 10.61L110.61 100z"
        data-name="Obecn\xE9 ikony"
      />
    </svg>
  );
}

export default SvgBBiconsErrorNotice;
